export default __webpack_public_path__ + "static/media/severe_liver_disease.5ad6a63e.png";